module.exports = __webpack_public_path__ + "img/公司业务—代理.99fb7c77.jpg";